<template>
  <div class="body">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,600;1,700&family=Poppins:wght@700&display=swap" rel="stylesheet">
      <Header />
      <Hero />
      <Grow />
      <Conversations />
      <Users />
      <Ready />
      <Footer />
  </div>
</template>

<script>
import Header from '../components/huddle-landing-page-curved-section/Header.vue';
import Hero from '../components/huddle-landing-page-curved-section/Hero.vue';
import Grow from '../components/huddle-landing-page-curved-section/Grow.vue';
import Conversations from '../components/huddle-landing-page-curved-section/Conversations.vue';
import Users from '../components/huddle-landing-page-curved-section/Users.vue';
import Ready from '../components/huddle-landing-page-curved-section/Ready.vue';
import Footer from '../components/huddle-landing-page-curved-section/Footer.vue';

export default {
  name: 'HuddleWcurves',
  components: {
    Header,
    Hero,
    Grow,
    Conversations,
    Users,
    Ready,
    Footer,
  },
};
</script>

<syyle src="../css/huddle-w-curves/global.css" scoped />
<style lang="scss" scoped>

  .body {

    /* colors */
    --pink: hsl(322, 100%, 66%);
    --light-pink: hsl(321, 100%, 78%);
    --light-red: hsl(0, 100%, 63%);
    --very-dark-cyan: hsl(192, 100%, 9%);
    --very-pale-blue: hsl(207, 100%, 98%);
    --pale-blue: hsl(207, 50%, 70%);
    --white: hsl(0, 0%, 100%);
    --gray-300: hsl(126, 8%, 53%);

    --border-radius: 0.5rem;

    /* spacing */
    --sm-spacer: 3rem;
    --bg-spacer: 6rem;

    /* fonts */
    --fs-h0: 5rem;
    --fs-h1: 3rem;
    --fs-h2: 1.8rem;
    --fs-normal: 0.9375rem;
    --fw-100: 100;
    --fw-normal: 400;
    --fw-600: 600;
    --fw-700: 700;
    --fw-900: 900;

    --ff-primary: 'Open Sans', sans-serif;
    --ff-alt:  'Poppins', sans-serif;

    font-family: var(--ff-primary);
    font-size: var(--fs-normal);
    text-align: center;

    @media (min-width: 50em) {
      --fs-h2: 3rem;
      --fs-normal: 1.25rem;
      --fs-h0: 6rem;
    }
  }
</style>
